// extracted by mini-css-extract-plugin
export default {"iframe_div":"PosterVideo_iframe_div__z4eXK","iframe":"PosterVideo_iframe__MsefP"};